/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ShellViewKey {
  static readonly LOGIN = 'shell/view/login';
  static readonly REGISTER = 'shell/view/register';
  static readonly RESET_PASSWORD = 'shell/view/reset-password';
  static readonly EMPLOYEE_SELECT = 'shell/view/employee-select';
}
